export const CUSTOMERS_REVIEWS_DEFAULTS = {
  title: 'The (Almost) 5 Star Insurance Company',
  subtitle:
    'Lemonade has earned 4.9 stars in the App store, and \n is also top-rated by Supermoney, Clearsurance, and others',
  thirdTitle: 'awarded the best contents insurance in the Netherlands by [link](link)',
  tweets: [],
};
